import './RoverSalesRoom.css';

interface RoverSalesRoomProps {
  availableRovers: number;
  metalsInStore: number;
  energyInStore: number;
  roversNextTurn: number;
  playerMoney: number;
  hasPurchasedRover: boolean;
  onPurchase: () => Promise<void>;
  onBack: () => void;
}

const ROVER_BASE_COST = 100;

export default function RoverSalesRoom({
  availableRovers,
  metalsInStore,
  energyInStore,
  roversNextTurn,
  playerMoney,
  hasPurchasedRover,
  onPurchase,
  onBack,
}: RoverSalesRoomProps) {
  const canAfford = playerMoney >= ROVER_BASE_COST;
  const canPurchase = canAfford && availableRovers > 0 && !hasPurchasedRover;

  return (
    <div className="rover-sales-room">
      <h2 className="room-title">
        <span className="room-icon">🤖</span>
        ROVER SALES - WORKSHOP
      </h2>

      <div className="room-content">
        {/* Rover Display */}
        <div className="rover-display">
          <div className="rover-grid">
            {Array.from({ length: Math.min(availableRovers, 4) }).map((_, i) => (
              <div key={i} className="rover-for-sale">
                <div className="rover-sprite-placeholder">🤖</div>
                <div className="for-sale-tag">FOR SALE</div>
              </div>
            ))}
            {availableRovers === 0 && (
              <div className="no-rovers">
                <p>⚠️ NO ROVERS AVAILABLE</p>
                <p className="small">Check back next turn!</p>
              </div>
            )}
          </div>
        </div>

        {/* Purchase Section */}
        <div className="purchase-section">
          <div className="price-info">
            <span className="label">Base Cost:</span>
            <span className="value">100 CT</span>
          </div>
          <div className="inventory-info">
            <span className="label">Available:</span>
            <span className="value highlight">{availableRovers} rovers</span>
          </div>

          {hasPurchasedRover ? (
            <div className="status-message success">
              ✅ You've already purchased a rover!<br/>
              Go to an outfitting room to configure it.
            </div>
          ) : (
            <button
              className="purchase-button"
              onClick={onPurchase}
              disabled={!canPurchase}
            >
              {!canAfford ? '❌ INSUFFICIENT FUNDS' : 
               availableRovers === 0 ? '❌ OUT OF STOCK' :
               '✅ PURCHASE ROVER - 100 CT'}
            </button>
          )}
        </div>

        {/* Construction Status */}
        <div className="construction-status">
          <h3>⚙️ CONSTRUCTION STATUS</h3>
          <div className="status-grid">
            <div className="status-item">
              <span className="label">Metals in Store:</span>
              <span className="value">{metalsInStore} units</span>
            </div>
            <div className="status-item">
              <span className="label">Energy in Store:</span>
              <span className="value">{energyInStore} units</span>
            </div>
            <div className="status-item full-width">
              <span className="label">Rovers Next Turn:</span>
              <span className="value highlight">{roversNextTurn} will be built</span>
            </div>
          </div>
          <div className="info-box">
            <p>ℹ️ Store needs <strong>50 metals + 25 energy</strong> per rover</p>
            <p className="small">Sell resources to help construction!</p>
          </div>
        </div>
      </div>

      <button className="back-button" onClick={onBack}>
        ← Back to Lobby
      </button>
    </div>
  );
}

